import React, { useState } from "react";
import { T } from "../theme";

// Click a date to change it; Enter / blur saves, Esc cancels. Shared by
// block sessions and ledger coaching rows so dates behave the same everywhere.
export function formatSessionDate(iso) {
  if (!iso) return "";
  return new Date(iso + "T00:00:00").toLocaleDateString("en-NZ", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
}

export default function EditableDate({ value, onChange, placeholder = "Set date", muted = false, strike = false, size = 13 }) {
  const [editing, setEditing] = useState(false);
  const commit = v => { if (v && v !== value) onChange(v); setEditing(false); };
  if (editing) {
    return <input type="date" defaultValue={value || new Date().toLocaleDateString("en-CA")} autoFocus
      onBlur={e => commit(e.target.value)}
      onKeyDown={e => { if (e.key === "Enter") commit(e.target.value); if (e.key === "Escape") setEditing(false); }}
      style={{ fontSize: size, fontWeight: 600, border: `1px solid ${T.threadline}`, borderRadius: T.radiusSm, padding: "4px 8px", color: T.root, outline: "none", fontFamily: T.fontSans }} />;
  }
  return (
    <span onClick={() => setEditing(true)} title="Click to change the date" style={{ fontSize: size, fontWeight: value ? 600 : 400, color: !value ? T.borderStrong : muted ? T.fgMuted : T.root, textDecoration: strike ? "line-through" : "none", cursor: "pointer", display: "inline-block", borderBottom: `1px dashed ${T.borderSubtle}`, paddingBottom: 1 }}>{value ? formatSessionDate(value) : placeholder}</span>
  );
}
